import ArchiveRegular from 'mini-fluent-svg-icons/lib/icons/ArchiveRegular';
import DeleteRegular from 'mini-fluent-svg-icons/lib/icons/DeleteRegular';
import EditRegular from 'mini-fluent-svg-icons/lib/icons/EditRegular';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import FolderRegular from 'mini-fluent-svg-icons/lib/icons/FolderRegular';
import MailInboxRegular from 'mini-fluent-svg-icons/lib/icons/MailInboxRegular';
import ProhibitedRegular from 'mini-fluent-svg-icons/lib/icons/ProhibitedRegular';
import SendRegular from 'mini-fluent-svg-icons/lib/icons/SendRegular';

/**
 * function to determine which icon is rendered for respective folder
 * @param folderId for which icon class is returned
 * @param isFavorite other than favourite folders, by default render folder icon
 */
export function getIconForFolder(folderId: string): string {
    const folderName = folderIdToName(folderId);
    switch (folderName) {
        case 'inbox':
            return MailInboxRegular;
        case 'sentitems':
            return SendRegular;
        case 'drafts':
            return EditRegular;
        case 'deleteditems':
            return DeleteRegular;
        case 'archive':
            return ArchiveRegular;
        case 'junkemail':
            return ProhibitedRegular;
        default:
            return FolderRegular;
    }
}
